module.exports = __webpack_public_path__ + "img/df-k.6f73ca2f.png";